//!!!!! TODO: Do not mutate state directly fix it asap!!!!!!
import React, {Component} from 'react'
import BaseComponent from '../base'
import Field from "../common/Field";
import i18 from "../../i18";
import Validator from "../common/Validator";
import api from "../../source/api";
import moment from "moment";
import NotificationSystem from "react-notification-system";
import PATH from "../../config/dev";

class BankTestInput extends BaseComponent {

    constructor(props) {
        super(props)
        this.state = {
            processing: false,
            fields: {
                bankFile: {value: '', error: '', role: {required: true}},
            },
            error: null,
            items: false,
        }
    }

    _addNotification = (msg, type, time = 4) => {
        this.refs.notificationSystem.addNotification({
            message: msg,
            level: type,
            position: 'tc',
            autoDismiss: time
        })
    }

    upload = () => {
        let validator = Validator.validate(this.state.fields)
        this.setState({
            fields: validator.fields,
            error: validator.error
        });

        if (this.state.error) {
            return;
        }

        document.body.classList.toggle('loading-body', true)
        this.setState({processing: true})


        api.postFile({url: 'bank/test-input', data: this.collectFormData()}, true).then((response) => {
            if (response.status === 200) {
                this.setState({
                    processing: false,
                    items: response.data.items
                })
                document.body.classList.remove('loading-body')

            }
        }).catch((err) => {
            document.body.classList.remove('loading-body')
            this.setState({
                processing: false,
                items: false
            })
            this._addNotification(err.response.data.error.message, 'error')
        })

    }

    collectFormData = () => {
        let form = new FormData();
        form.append('bankStatementFile', document.querySelector('#bankFile').files[0])
        return form
    }

    setValue = (name, value, error) => {
        let fields = this.state.fields;
        fields[name].value = value;
        fields[name].error = error;
        this.setState({fields: fields});
    }

    render() {
        return (
            <section id='bank-takarek-bank-replacer' className='my-5'>
                <div className='container'>

                    <div className='header'>
                        <h1>
                            Bankszámlakivonat feldolgozó
                        </h1>
                        <p>
                            Ezzel a modullal lehet ellenőrizni, hogy a Beeker hogyan fogja értelmezni a beküldött bankszámlkivonatot.
                        </p>
                    </div>

                    <div className='row'>
                        <div className='col-md-10 offset-md-2 my-5'>
                            <table className='table table-bordered'>
                                <thead>
                                <tr>
                                    <th>Megnevezés</th>
                                    <th>Mező</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>
                                        Bank számlakivonat file
                                    </td>
                                    <td>
                                        <Field
                                            type='file'
                                            id='bankFile'
                                            name='bankFile'
                                            fileUploadEndpoint=''
                                            classLabel='control-label'
                                            classInput='file-input'
                                            setValue={this.setValue.bind(this)}
                                            state={this.state}
                                        />
                                    </td>
                                </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>

                    <div className='next-step-btn-container text-center'>
                        <a
                            onClick={() => this.upload()}
                            className={this.state.processing ? 'disabled next-step' : 'next-step'}
                        >
                            Betöltés
                        </a>
                    </div>
                </div>

                {this.state.items === false ? '' :
                    <div className='container-fluid'>
                        <table className='table table-striped mt-5'>
                            <thead>
                            <tr>
                                <th>ID</th>
                                <th>Nap</th>
                                <th>Tranzakció típusa</th>
                                <th>Partner</th>
                                <th>Partne bankszámla száma</th>
                                <th>Összeg</th>
                                <th>Deviza</th>
                                <th>Megjegyzes</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.items.map((item) => {
                                return <tr>
                                    <td>{item.id}</td>
                                    <td>{item.day}</td>
                                    <td>{item.typeOfTraffic}</td>
                                    <td>{item.companyName}</td>
                                    <td>{item.invoiceNumber}</td>
                                    <td>{item.sum}</td>
                                    <td>{item.currency}</td>
                                    <td>{item.announcement}</td>
                                </tr>
                            })}
                            </tbody>
                            <tfoot>
                            <tr className="font-weight-bold">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>{
                                    this.state.items.map(item => item.sum).reduce((prev, next) => prev + next)
                                }</td>
                                <td></td>
                                <td></td>
                            </tr>
                            </tfoot>

                        </table>
                    </div>
                }

                <NotificationSystem ref='notificationSystem'/>
            </section>
        )
    }
}

export default BankTestInput


// WEBPACK FOOTER //
// ./src/components/bank/BankTestInput.js